import { render, staticRenderFns } from "./Person2.vue?vue&type=template&id=5e824294"
import script from "./Person2.vue?vue&type=script&lang=js"
export * from "./Person2.vue?vue&type=script&lang=js"
import style0 from "./Person2.vue?vue&type=style&index=0&id=5e824294&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports